// extracted by mini-css-extract-plugin
export default {"root":"HomePage_root__Dlq4u","heroWrap":"HomePage_heroWrap__Aln06","main":"HomePage_main__fHNah"};